import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  shipmentStatus: { data: [], loading: true },
  activeShipmentMetrics: { data: [], loading: true },
  fleetCount: { data: [], loading: true },
  fleetStatus: { data: [], loading: true },
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setShipmentStatus: (state, action) => {
      state.shipmentStatus.loading = false;
      if (action.payload.length !== 0) {
        state.shipmentStatus.data = action.payload;
      }
    },
    setActiveShipmentMetrics: (state, action) => {
      if (action.payload.length !== 0) {
        state.activeShipmentMetrics.data = action.payload;
        state.activeShipmentMetrics.loading = false;
      }
    },
    setFleetCount: (state, action) => {
      if (action.payload.length !== 0) {
        state.fleetCount.data = action.payload;
        state.fleetCount.loading = false;
      }
    },
    setFleetStatus: (state, action) => {
      state.fleetStatus.loading = false;
      if (action.payload.length !== 0) {
        state.fleetStatus.data = action.payload;
      }
    },
  },
});

export const {
  setShipmentStatus,
  setActiveShipmentMetrics,
  setFleetCount,
  setFleetStatus,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
